import { render, staticRenderFns } from "./quantity-unit-input.vue?vue&type=template&id=596c58a4&scoped=true&"
import script from "./quantity-unit-input.vue?vue&type=script&lang=js&"
export * from "./quantity-unit-input.vue?vue&type=script&lang=js&"
import style0 from "./quantity-unit-input.vue?vue&type=style&index=0&id=596c58a4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "596c58a4",
  null
  
)

export default component.exports